// ES6 Modules or TypeScript
import Swal from 'sweetalert2/dist/sweetalert2';
import settings from './settings';

export default function confirm(options, onConfirm) {
  Swal.fire({
    ...settings,
    cancelButtonText: 'Cancel',
    showConfirmButton: true,
    showCancelButton: true,
    ...options,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
}
